import { setBingoScheduleAndLobbyData, setIsBingoScheduleLoaded } from '@interlayer/js/custom/components/main/BingoScheduler/store/actions';

import { getBingoScheduleAndLobby } from '../../server';
import { FetchBingoScheduleProps } from '../../types';
import mapBingoScheduleGames from '../utilities';

const fetchBingoScheduleAndLobby = ({
    dispatch, games, bingoRegion, casinoName, lobbyName, pageSize
}: FetchBingoScheduleProps): void => {
    if (games) {
        getBingoScheduleAndLobby({ bingoRegion, casinoName, lobbyName, pageSize })
            .then(([bingoGames, lobbyGames]) =>
                mapBingoScheduleGames({
                    siteSchedulesGames: bingoGames.data.siteSchedules,
                    lobbyGames: lobbyGames.data.games,
                    jackpots: lobbyGames.data.jackpots,
                    adminGames: games
                })
            )
            .then((gamesData) => {
                dispatch(setBingoScheduleAndLobbyData(gamesData));
                dispatch(setIsBingoScheduleLoaded(true));
            })
            .catch((error) => {
                throw error;
            });
    }
};

export default fetchBingoScheduleAndLobby;
